import { Session } from 'types/listings';

const getFirstAvailableDateFromSessions = (
  sessions?: Session[] | null,
): Session | undefined => {
  if (!sessions || sessions.length === 0) return undefined;

  return sessions.reduce((earliest, session) => {
    if (!earliest) return session;
    return new Date(session.startDateTime) < new Date(earliest.startDateTime)
      ? session
      : earliest;
  }, undefined as Session | undefined);
};

export default getFirstAvailableDateFromSessions;
